import React from 'react';
import { Mail, ArrowRight } from 'lucide-react';

// INSTRUCTIONS:
// 1. Log in to Kit.com (ConvertKit)
// 2. Go to Grow -> Landing Pages & Forms
// 3. Create a new Form (Inline is best)
// 4. In the "Embed" settings, look for the HTML code.
// 5. Find the numeric ID in the action URL (e.g., https://app.kit.com/forms/1234567/subscriptions)
// 6. Replace 'YOUR_FORM_ID' below with that number.

const KIT_FORM_ID = "8890093"; 

const EmailCapture: React.FC = () => {
  return (
    <section id="signup" className="py-32 bg-white px-6">
      <div className="max-w-2xl mx-auto text-center space-y-12">
        <div className="space-y-6">
          <h2 className="text-5xl md:text-7xl tracking-tighter font-black">Stay in the Loop</h2>
          <p className="text-neutral-500 font-normal text-lg max-w-lg mx-auto leading-relaxed">
            Our salons are intimate and capacity is limited. Join our curated community for exclusive invites and updates.
          </p>
        </div>

        <div className="max-w-md mx-auto">
          <form 
            action={`https://app.kit.com/forms/${KIT_FORM_ID}/subscriptions`} 
            method="post"
            target="_blank"
            className="space-y-4"
          >
            <div className="relative group">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-neutral-300 group-focus-within:text-terracotta transition-colors" size={18} />
              <input 
                type="email" 
                name="email_address" 
                placeholder="EMAIL ADDRESS" 
                required 
                className="w-full pl-12 pr-4 py-5 rounded-lg bg-cream border-2 border-transparent focus:border-terracotta/20 focus:bg-white outline-none text-charcoal text-xs font-bold tracking-widest placeholder:text-neutral-300 transition-all shadow-sm"
              />
            </div>
            
            <button 
              type="submit"
              className="group flex items-center justify-center gap-4 w-full bg-terracotta text-white px-8 py-5 rounded-lg font-black text-[10px] uppercase tracking-[0.4em] shadow-[0_10px_30px_-10px_rgba(192,108,93,0.4)] hover:bg-[#A85B4E] hover:scale-[1.02] transition-all"
            >
              <span>Join the Community</span>
              <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </form>
        </div>
        
        <div className="pt-12 space-y-4">
          <p className="text-[9px] uppercase tracking-[0.2em] text-neutral-200 font-medium text-center">
            Strict Privacy Protocol. No Spam.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EmailCapture;